import type { PerformancePart } from '@tunasong/schemas'

/**
 * Datalist suggestions for the inputs list. Production conventions, not rules: every field stays free text, and the
 * lists are part of the FOH review with the preset tiers.
 */
export const micDiSuggestions = ['DI', 'Line', 'Dynamic', 'Condenser', 'Kick mic'] as const

const sourcesByPart: Partial<Record<PerformancePart, string[]>> = {
  drums: ['Kick', 'Snare', 'Hi-hat', 'Tom 1', 'Tom 2', 'Floor tom', 'OH L', 'OH R'],
  bass: ['Bass amp', 'Bass DI'],
  guitar: ['Guitar amp', 'Guitar DI', 'Acoustic'],
  keys: ['Keys', 'Keys L', 'Keys R'],
  vocals: ['Lead vocal', 'Backing vocal'],
}

/** Source suggestions for the parts a member plays, or for every part when none are set */
export const sourceSuggestions = (parts: readonly PerformancePart[]) => {
  const chosen = parts.length > 0 ? parts : (Object.keys(sourcesByPart) as PerformancePart[])
  return [...new Set(chosen.flatMap(part => sourcesByPart[part] ?? []))]
}
